import { env } from '@/env'
import { api } from '@/shared/lib/api'

export const useQrCode = () => {
  const extractCodeIdFromUrl = (url: string): string | null => {
    try {
      const parsedUrl = new URL(url)
      const parsedBase = new URL(env.NEXT_PUBLIC_EVNTTZ_CODES_BASE_URL)

      if (
        parsedUrl.origin !== parsedBase.origin ||
        !parsedUrl.pathname.startsWith(parsedBase.pathname)
      ) {
        return null
      }

      const relativePath = parsedUrl.pathname.replace(parsedBase.pathname, '')
      const id = relativePath.replace(/^\/+|\/+$/g, '')

      return id || null
    } catch {
      return null
    }
  }

  const getQrCode = async (data: string) => {
    const id = extractCodeIdFromUrl(data)

    if (!id) throw new Error('invalid_qr_code_url')

    try {
      const response = await api.get(`/user/qr_codes/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  }

  return { getQrCode }
}
